import Feature from "ol/Feature";
import Point from "ol/geom/Point";
import { fromLonLat } from "ol/proj";
import Icon from "ol/style/Icon";
import Style from "ol/style/Style";

import ZnvHeader from "../components/ZnvHeader";
// Haltausfall Laim
import ConstructionLaimCity2028Icon from "../img/events/construction-laim-city-2028.svg";
import ConstructionIcon from "../img/events/construction.svg";
// import LandesgartenschauIcon from "../img/events/landesgartenschau.svg";
// import LandesgartenschauHeader from "../components/LandesgartenschauHeader";
import OktoberfestIcon from "../img/events/oktoberfest.svg";
import ZnvIcon from "../img/events/znv.svg";
import interpolate from "../utils/interpolate";

import type { Map } from "ol";

import type { EventConfig, EventConfigProperties } from "../configs/common";

const events: EventConfig[] = [
  // landesgartenschau;
  // new Feature({
  //   from: "2024-05-15T00:00Z",
  //   until: "2024-10-06T23:59Z",
  //   geometry: new Point([1308606, 6134992]), // Heimstetten bahnhof
  //   style: (map) => () => {
  //     const zoom = map.getView().getZoom();
  //     const scale = interpolate(zoom, [
  //       [10, 0.1],
  //       [12, 0.2],
  //       [14, 0.3],
  //     ]);
  //     return new Style({
  //       image: new Icon({
  //         src: LandesgartenschauIcon,
  //         scale,
  //       }),
  //     });
  //   },
  //   stationUic: 8002715,
  //   stationBanner: <LandesgartenschauHeader />,
  //   onClick: () => {
  //     window.open("https://kirchheim2024.de/", "_blank");
  //   },
  // }),
  // Oktoberfest
  new Feature({
    from: "2026-09-19T00:00Z",
    geometry: new Point(fromLonLat([11.550552, 48.130945])), // Between Hbf and Hackerbrücke
    onClick: () => {
      window.open("https://www.s-bahn-muenchen.de/oktoberfest", "_blank");
    },
    style: (map) => () => {
      const zoom = map.getView().getZoom() ?? 0;
      if (zoom < 11) {
        return null;
      }
      const scale = interpolate(zoom, [
        [10, 0.1],
        [12, 0.2],
        [14, 0.3],
      ]);
      return new Style({
        image: new Icon({
          scale,
          src: OktoberfestIcon,
        }),
      });
    },
    until: "2026-10-04T23:59Z",
  }),

  // Zukunft nah verkehr
  new Feature({
    from: "2025-09-09T00:00:00Z",
    geometry: new Point([1287094, 6130027]), // Heimstetten bahnhof
    onClick: () => {
      window.open("http://zukunftnahverkehr.de/iaa", "_blank");
    },
    stationBanner: <ZnvHeader />,
    stationUic: 8000261,
    style: (map) => () => {
      const zoom = map.getView().getZoom() ?? 0;
      const scale = interpolate(zoom, [
        [10, 0.1],
        [12, 0.2],
        [14, 0.35],
      ]);

      const displacementY = interpolate(zoom, [
        [5, -40],
        [6, -50],
        [14, 0],
      ]);
      return new Style({
        image: new Icon({
          anchor: [0.5, 0.5],
          displacement: [0, displacementY],
          scale: scale,
          size: [150, 150],
          src: ZnvIcon,
        }),
      });
    },
    until: "2025-09-14T23:59Z",
  }),

  // Haltausfall Laim
  new Feature({
    from: "2026-08-25T00:00Z",
    geometry: new Point([1280583, 6130907]),
    style: (map: Map) => () => {
      const zoom: number = map.getView().getZoom()!;

      const scale: number = interpolate(zoom, [
        [5, 3],
        [6.5, 5],
      ]);

      const displacementY: number = interpolate(zoom, [
        [10, 20],
        [13, 40],
      ]);
      return new Style({
        image: new Icon({
          displacement: [0, displacementY],
          scale,
          src: ConstructionIcon,
        }),
      });
    },
    until: "2027-07-01T00:00Z",
  }),
  new Feature<Point, EventConfigProperties>({
    from: "2026-08-25T00:00Z",
    geometry: new Point([1280583, 6130907]),
    style: (map: Map) => () => {
      const zoom: number = map.getView().getZoom()!;

      // The image does not exceed the maximum width of the window on mobile devices
      const imgWidth = 80;
      const maxWidth = window.innerWidth;
      const scaleForMaxZoom = Math.min(7, maxWidth / imgWidth);

      const scale: number = interpolate(zoom, [
        [11.5, 0],
        [12, 2],
        [15, scaleForMaxZoom],
      ]);

      const displacementX: number = interpolate(zoom, [
        [11.5, 0],
        [12, -50],
        [15, -10],
      ]);

      const displacementY: number = interpolate(zoom, [
        [11.5, 0],
        [12, -30],
        [15, -130],
      ]);
      return new Style({
        image: new Icon({
          displacement: [displacementX, displacementY],
          scale,
          src: ConstructionLaimCity2028Icon,
        }),
      });
    },
    until: "2027-07-01T00:00Z",
  }),
];
export default events;
